const initialState = { home_amount: 0, show_fare_amount: 0 };

const ReservationBalanceReducer = (state = initialState, action) => {
  switch (action.type) {
    case "setreservationBalance":
      state = action.payload;
      return state;
    default:
      return state;
  }
};

export default ReservationBalanceReducer;
